import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var SetOrderAsCollectedErrorCodeV1;
(function (SetOrderAsCollectedErrorCodeV1) {
    SetOrderAsCollectedErrorCodeV1[SetOrderAsCollectedErrorCodeV1["AlreadyCollected"] = 16200] = "AlreadyCollected";
    SetOrderAsCollectedErrorCodeV1[SetOrderAsCollectedErrorCodeV1["OrderExpired"] = 16300] = "OrderExpired";
})(SetOrderAsCollectedErrorCodeV1 || (SetOrderAsCollectedErrorCodeV1 = {}));
export class SetOrderAsCollectedErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to set order as collected. API error code ${errorCode}: ${SetOrderAsCollectedErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getSetOrderAsCollectedErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SetOrderAsCollectedErrorCodeV1).includes(errorCode)
        ? new SetOrderAsCollectedErrorV1(errorCode)
        : error;
}
//# sourceMappingURL=set-order-as-collected-error.js.map